module.exports = "https://r.nearpod.com/assets/media/image/mcq_icon-c54c5f2468e653e1a90947f0135e2df2.svg";